module.exports = __webpack_public_path__ + "static/img/img90.c955b9ee.png";